import { render, staticRenderFns } from "./ListarPerifericosView.vue?vue&type=template&id=7360d56c&scoped=true"
import script from "./ListarPerifericosView.vue?vue&type=script&lang=js"
export * from "./ListarPerifericosView.vue?vue&type=script&lang=js"
import style0 from "./ListarPerifericosView.vue?vue&type=style&index=0&id=7360d56c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7360d56c",
  null
  
)

export default component.exports